module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-error-fd3ba2bc6f1ddf092efc1440d6c7de2b.svg";